<div class="modal-header">
  <h6 class="modal-title" id="modal-basic-title">Pallets</h6>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body overflow-auto">
  <ov-suite-table
    [showIndex]="false"
    [striped]="true"
    [selectableRows]="false"
    [showFiller]="false"
    [data]="data?.data || []"
    [loading]="false"
    [columnData]="metadata?.table"
    [totalCount]="data?.totalCount"
    [pageSize]="pageSize"
    (changePage)="changePage($event)"
    [hideColumnKeys]="[]"
    [keyStore]="metadata?.name"
  ></ov-suite-table>
</div>
